<template>
    <div class="column_start_start w-full py-2 px-[6%] bg-[#FAFAFA] mt-5" v-if="isDelivery || isPickUp">
        <div class="row_center_between w-full pt-3">
            <text class="title">{{ infoTitle }}</text>
        </div>
        <deliveryInfo v-if="isDelivery" />
        <pickUpInfo v-if="isPickUp" />
    </div>
</template>

<script>
import deliveryInfo from "@/components/store/deliveryInfo.vue"
import pickUpInfo from "@/components/store/pickUpInfo.vue"

export default {
    name: 'ConsumptionModeDetails',
    components: {
        deliveryInfo: deliveryInfo,
        pickUpInfo: pickUpInfo
    },
    props: {
        // 消費模式：'dineIn', 'takeOut', 'pickUp', 'delivery', 'retailPickUp', 'retailDelivery'
        consumptionMethod: {
            type: String,
            required: true,
            validator: (value) => ['dineIn', 'takeOut', 'pickUp', 'delivery', 'retailPickUp', 'retailDelivery'].includes(value)
        }
    },
    computed: {
        infoTitle() {
            if (this.consumptionMethod === 'retailDelivery') return '宅配資訊'
            if (this.consumptionMethod === 'retailPickUp') return '取貨資訊'
            return '取餐資訊'
        },
        // 是否為店家外送模式
        isDelivery() {
            return ['delivery', 'retailDelivery'].includes(this.consumptionMethod)
        },
        // 零售自取需要顯示取貨日期，但不需要時間
        isPickUp() {
            return ['pickUp', 'retailPickUp'].includes(this.consumptionMethod)
        }
    }
}
</script>

<style lang="scss" scoped>
// 繼承父組件的樣式，無需額外樣式
</style>
